import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AdminSignInPage } from '@/features/auth/admin-signin-page';

const searchSchema = z.object({ next: z.string().optional().catch(undefined) });

/**
 * Django admin's (superusers) and the back office's (staff) sign-in, with KorOS
 * two-step sign-in: `/django-admin/login/` and `/backoffice/login/` send the
 * browser here. Online-only: it is a round trip to KorOS.
 */
export const Route = createFileRoute('/auth/admin-signin')({
  validateSearch: searchSchema,
  component: AdminSignInPage,
});
